import {Navbar} from '@genomics-dev/denim-components';
import classNames from 'classnames';
import {
    useMemo,
    useState,
} from 'react';
import {Outlet} from 'react-router-dom';
import {Logotype} from '../../components';
import {useSanitisedPathname} from '../../hooks';
import {Name} from '../linear-flow/Name';

export function MinimalLayout(props) {
    const {showName = false} = props;

    const sanitisedPathname = useSanitisedPathname();
    const [className, setClassName] = useState('');

    const mainClasses = useMemo(
        () => classNames(className, sanitisedPathname),
        [className, sanitisedPathname],
    );

    const navbarContent = (
        <div className={'linear-flow-navbar'}>
            <Logotype homeLink={true} />
            {showName && <Name />}
        </div>
    );

    return (
        <div className={'minimal-layout'}>
            <Navbar
                desktopContent={navbarContent}
                mobileContent={navbarContent}
            />
            <main className={mainClasses}>
                <Outlet context={{setClassName}} />
            </main>
        </div>
    );
}
